import { useEffect } from 'react'

export const useClickOutside = (
    triggerRef: React.RefObject<HTMLElement>,
    containerRef: React.RefObject<HTMLElement>,
    isOpen: boolean,
    onClose: () => void,
) => {
    useEffect(() => {
        if (!isOpen) return
        const handler = (e: MouseEvent) => {
            const t = e.target as Node
            if (!triggerRef.current || !containerRef.current) return
            if (!triggerRef.current.contains(t) && !containerRef.current.contains(t)) {
                onClose()
            }
        }
        document.addEventListener('click', handler, true)
        document.addEventListener('mousedown', handler, true)
        return () => {
            document.removeEventListener('click', handler, true)
            document.removeEventListener('mousedown', handler, true)
        }

    }, [isOpen, triggerRef, containerRef, onClose])
}

export default useClickOutside
